import { render } from "./ButtonComponent.vue?vue&type=template&id=67115656"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programas\\laragon\\www\\projects\\vuejs\\adivina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__